import { style, styleVariants } from '@vanilla-extract/css';
import {
  bodyTextPreset,
  borderWidthVars,
  captionTextPreset,
  radiusVars,
  spacingVars,
  titleTextPreset,
} from '@tundr/ds-foundations';
import { semanticTokenVars, shadowVars } from '@tundr/ds-tokens';
import { ToastVariant } from './Toast.types';

const TOAST_BORDER_RADIUS = '12px';
const TOAST_WIDTH = '460px';
const ICON_CIRCLE_SIZE = '46px';
const CLOSE_ICON_SIZE = '24px';

export const containerClass = style({
  display: 'flex',
  alignItems: 'flex-start',
  gap: spacingVars.lg,
  width: TOAST_WIDTH,
  maxWidth: '100%',
  padding: spacingVars.md,
  borderRadius: TOAST_BORDER_RADIUS,
  overflow: 'clip',
});

export const containerVariantClass = styleVariants({
  [ToastVariant.INFO]: {
    backgroundColor: semanticTokenVars.feedback.info.default.subtle,
  },
  [ToastVariant.SUCCESS]: {
    backgroundColor: semanticTokenVars.feedback.success.default.subtle,
  },
  [ToastVariant.WARNING]: {
    backgroundColor: semanticTokenVars.feedback.warning.default.subtle,
  },
  [ToastVariant.ERROR]: {
    backgroundColor: semanticTokenVars.feedback.error.default.subtle,
  },
});

export const elevatedClass = style({
  boxShadow: shadowVars.md,
});

export const fullWidthClass = style({
  width: '100%',
});

export const sectionClass = style({
  display: 'flex',
  flex: 1,
  gap: spacingVars.md,
  alignItems: 'flex-start',
  minWidth: 0,
});

export const iconCircleClass = style({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: ICON_CIRCLE_SIZE,
  minWidth: ICON_CIRCLE_SIZE,
  height: ICON_CIRCLE_SIZE,
  borderRadius: '50%',
  flexShrink: 0,
  backgroundColor: semanticTokenVars.surface.background.neutral.default.base,
});

export const iconCircleVariantClass = styleVariants({
  [ToastVariant.INFO]: {
    color: semanticTokenVars.feedback.info.default.base,
  },
  [ToastVariant.SUCCESS]: {
    color: semanticTokenVars.feedback.success.default.base,
  },
  [ToastVariant.WARNING]: {
    color: semanticTokenVars.feedback.warning.default.base,
  },
  [ToastVariant.ERROR]: {
    color: semanticTokenVars.feedback.error.default.base,
  },
});

export const contentClass = style({
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  gap: spacingVars.md,
  minWidth: 0,
});

export const textBoxClass = style({
  display: 'flex',
  flexDirection: 'column',
  gap: spacingVars.xs,
  minWidth: 0,
});

export const messageClass = style({
  ...titleTextPreset,
  overflowWrap: 'anywhere',
});

export const descriptionClass = style({
  ...bodyTextPreset,
  overflowWrap: 'anywhere',
});

export const detailRowClass = style({
  display: 'flex',
  alignItems: 'center',
  gap: spacingVars.sm,
  minWidth: 0,
});

export const detailTextClass = style({
  ...captionTextPreset,
  overflowWrap: 'anywhere',
});

export const closeButtonClass = style({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: CLOSE_ICON_SIZE,
  height: CLOSE_ICON_SIZE,
  flexShrink: 0,
  padding: 0,
  margin: 0,
  border: 'none',
  backgroundColor: 'transparent',
  cursor: 'pointer',
  lineHeight: 0,
  borderRadius: radiusVars.sm,
  selectors: {
    '&:focus-visible': {
      outline: `${borderWidthVars.xs} solid ${semanticTokenVars.border.brand.base}`,
      outlineOffset: '2px',
    },
  },
});

export const closeButtonVariantClass = styleVariants({
  [ToastVariant.INFO]: {
    color: semanticTokenVars.feedback.info.default.base,
  },
  [ToastVariant.SUCCESS]: {
    color: semanticTokenVars.feedback.success.default.base,
  },
  [ToastVariant.WARNING]: {
    color: semanticTokenVars.feedback.warning.default.base,
  },
  [ToastVariant.ERROR]: {
    color: semanticTokenVars.feedback.error.default.base,
  },
});
